import { Stack, TextField, Box, Typography, Modal, Button } from '@mui/material';
import { LocalizationProvider, MobileDatePicker } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';

import { updatePlaytime } from '../../services/Playtime';
import { setError } from '../../services/Errors';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const EditModal = ({ editState }) => {
  const { edit, setEdit } = editState;

  const handleUpdatePlaytime = () => {
    if (Number(edit.hours) > 24 || Number(edit.minutes) > 60) return;

    updatePlaytime(edit.id, { date: edit.date, hours: Number(edit.hours), minutes: Number(edit.minutes) })
      .then(() => {
        localStorage.removeItem('summaryObj');
        setEdit({ modal: false });
      })
      .catch((error) => {
        console.log('error', error);
        setError('not-relevant', error.message);
      });
  };

  return (
    <div>
      <Modal open={edit.modal} onClose={() => setEdit({ modal: false, id: edit.id })}>
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2" mb={1}>
            Rediger registering
          </Typography>
          <Typography variant="body1" mb={3}>
            Fyll inn riktig informasjon nedenfor og trykk oppdater for å oppdatere registeringen
          </Typography>
          <Stack spacing={2}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <MobileDatePicker
                label="Dato"
                maxDate={new Date()}
                inputFormat="dd.MM.yyyy"
                value={new Date(edit?.date?.seconds * 1000)}
                onChange={(newDate) =>
                  setEdit({ ...edit, date: { seconds: newDate.getTime() / 1000, milliseconds: newDate.getTime() } })
                }
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            <TextField
              label="Timer"
              value={edit?.hours}
              onChange={({ target }) => setEdit({ ...edit, hours: target.value })}
              fullWidth
            />
            <TextField
              label="Minutter"
              value={edit?.minutes}
              onChange={({ target }) => setEdit({ ...edit, minutes: target.value })}
              fullWidth
            />
            <Button variant="contained" onClick={handleUpdatePlaytime}>
              Lagre
            </Button>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
};

export default EditModal;
